var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { limitTextWithEllipsis } from 'smartpi-core';
import { Container } from 'typedi';
import * as Sentry from '@sentry/browser';
import { config } from '../config';
import { Analytics } from './analytics';
import { h5AuthApiClient } from './api';
import { AuthManager } from './auth';
import { shareManager } from './share';
import { LocalStorage } from './storage';
import { urls } from './urls';
import { wechatClient } from './wechat';
var localStorage = new LocalStorage('user');
var UserManager = /** @class */ (function () {
    function UserManager() {
    }
    UserManager.prototype.getUser = function () {
        return this.user;
    };
    UserManager.prototype.getUserNameWithEllipsis = function () {
        return limitTextWithEllipsis(this.user && this.user.name, 6);
    };
    UserManager.prototype.setUser = function (user) {
        this.user = user;
        Analytics.identify(user);
        Sentry.configureScope(function (scope) {
            scope.setUser({
                id: "" + user.id,
                username: user.name,
                extra: {
                    mobile: user.mobile,
                },
            });
        });
    };
    UserManager.prototype.autoLogin = function (debug, fakeToken) {
        if (debug === void 0) { debug = config.DEBUG; }
        if (fakeToken === void 0) { fakeToken = config.FAKE_TOKEN; }
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.user) {
                            return [2 /*return*/, this.user];
                        }
                        if (debug && fakeToken) {
                            Container.get(AuthManager).setToken(fakeToken);
                        }
                        if (!Container.get(AuthManager).isAuthenticated()) {
                            throw new Error('Not authenticated');
                        }
                        return [4 /*yield*/, h5AuthApiClient.getCurrentUser()];
                    case 1:
                        user = _a.sent();
                        this.setUser(user);
                        return [4 /*yield*/, shareManager.userLanded()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, user];
                }
            });
        });
    };
    UserManager.prototype.redirectToWechatLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var appId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.user) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, wechatClient.getAppId()];
                    case 1:
                        appId = _a.sent();
                        window.location.replace(urls.getWechatOAuthUrl(appId));
                        return [2 /*return*/];
                }
            });
        });
    };
    UserManager.prototype.loginWithWechat = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, user, token;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.user) {
                            return [2 /*return*/, this.user];
                        }
                        return [4 /*yield*/, h5AuthApiClient.authorizeWithWechat(code)];
                    case 1:
                        _a = _b.sent(), user = _a.user, token = _a.token;
                        this.setUser(user);
                        // 登录成功，设定鉴权token
                        Container.get(AuthManager).setToken(token);
                        return [4 /*yield*/, shareManager.userLanded()];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, user];
                }
            });
        });
    };
    UserManager.prototype.bindMobileWithCode = function (mobile, code) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, user, token;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, h5AuthApiClient.verifyCellphoneCode(mobile, code)];
                    case 1:
                        _a = _b.sent(), user = _a.user, token = _a.token;
                        // 登录成功，设定User和鉴权token
                        this.setUser(user);
                        Container.get(AuthManager).setToken(token);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    UserManager.prototype.hasBindMobile = function () {
        if (this.user && this.user.mobile) {
            return true;
        }
        return false;
    };
    UserManager.prototype.addUserInputMobile = function (mobile) {
        localStorage.setItem('userInpputMobile', mobile);
    };
    UserManager.prototype.getUserInputMobile = function () {
        return localStorage.getItem('userInpputMobile');
    };
    UserManager.prototype.clearUserInputMobile = function () {
        localStorage.removeItem('userInpputMobile');
    };
    UserManager.prototype.preBindUserWithMobile = function (mobile) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, h5AuthApiClient.preBindUserWithMobile(mobile)];
                    case 1:
                        user = _a.sent();
                        this.setUser(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    return UserManager;
}());
export { UserManager };
//# sourceMappingURL=user.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/services/user.js
// module id = 167
// module chunks = 0